<template>
  <div>
    <el-descriptions title="" :column="1">
      <el-descriptions-item label="用户名称">{{ userData.identity == 'projectAdmin' ? '系统管理员' : userData.identity ==
        'operation' ? '巨基运营' : userData.name }}</el-descriptions-item>
      <el-descriptions-item label="手机号码">{{ userData.phone ?? "-" }}
        <el-button type="text" style="margin: 0 0 0 10px; padding: 0;" @click="changeCom('editPhone')"
          v-if="userData.phone">修改手机号码</el-button>
      </el-descriptions-item>
      <el-descriptions-item label="上次登录时间">{{ userData.latestLoginTime }}</el-descriptions-item>
    </el-descriptions>
    <div style="text-align: right">
      <el-button type="primary" @click="changeCom('editPassword')">修改登录密码</el-button>
      <el-button type="primary" @click="confirm">退出登录</el-button>
    </div>
  </div>
</template>

<script>
import { dateFtt } from "@/assets/js/utils";
export default {
  data() {
    return {
      userData: {},
    };
  },
  methods: {
    changeCom(type) {
      this.$parent.showCom = type;
    },
    confirm() {
      this.$confirm("确定退出登录？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$store.dispatch("logout");
          this.$store.commit("SET_ROUTE", []);
        })
        .catch(() => { });
    },
  },
  created() {
    this.userData = JSON.parse(window.sessionStorage.getItem("userInfo"));
    this.userData.latestLoginTime =
      this.userData.lastLoginTs && this.userData.lastLoginTs != 0
        ? dateFtt("yyyy-MM-dd hh:mm", new Date(this.userData.lastLoginTs))
        : "-";
  },
};
</script>

<style></style>